import COLOR from "../../../constants/colors";

const styles = {
  postsBox: {
    padding: "24px 0",
    background: COLOR.whiteSmoke,
    flexDirection: "column",
  },
  post: {
    background: COLOR.blue,
  },
};

export default styles;
